<template>
<div>
    <div>
        <img src="https://ui-avatars.com/api/?name=Miroslav+Ivkovic&color=7F9CF5&background=EBF4FF" />
    </div>
    <div>
        <button>Otpremi sliku</button>
    </div>
</div>
</template>
<script>
export default {

    props: {
        member: Object
    }
    
}
</script>